import React, { PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import pick from 'lodash/pick';
import { FormattedMessage } from 'react-intl';
import { TextButton, SecondaryGhostButton } from '@bibliocommons/base-buttons';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { locationShape } from 'react-router';
import FeedbackModal from './FeedbackModal';

import './PreviewBar.scss';

const FEEDBACK_MODAL_KEY = 'feedback-modal';

/** @extends React.Component */
export default class PreviewBar extends BcReactComponent {
  constructor (props) {
    super(props);
    this.bindAll('handleOpen', 'handleClose', 'handleOptOut', 'renderOptInActions');
  }

  handleOpen () {
    this.props.modalActions.openModal(FEEDBACK_MODAL_KEY);
  }

  handleClose () {
    this.props.modalActions.closeModal(FEEDBACK_MODAL_KEY);
  }

  handleOptOut () {
    this.props.previewActions.optOut(this.props.featureName, pick(this.props.location, ['pathname']));
  }

  renderFeedbackModal () {
    if (this.props.optedIn) {
      return (
        <FeedbackModal
          featureName={this.props.featureName}
          handleClose={this.handleClose}
          modalKey={FEEDBACK_MODAL_KEY}
          previewActions={this.props.previewActions}
          previewTransactions={this.props.previewTransactions}
        />
      );
    }

    return null;
  }

  renderOptInActions () {
    return (
      <div className="bar-actions">
        <TextButton
          handleClick={this.props.previewActions.dismissPreview}
          className="dismiss-opt-in-button"
          dataKey="dismiss-opt-in-button"
        >
          <FormattedMessage id="no_thanks" />
        </TextButton>
        <SecondaryGhostButton
          className="preview-button"
          dataKey="preview-button"
          handleClick={this.props.previewActions.optIn}
        >
          <FormattedMessage id="preview_label" />
        </SecondaryGhostButton>
      </div>
    );
  }

  renderOptOutActions () {
    return (
      <div className="bar-actions">
        <TextButton className="leave-preview-button" handleClick={this.handleOptOut} dataKey="leave-preview-button">
          <FormattedMessage id="leave_preview" />
        </TextButton>
        <SecondaryGhostButton
          className="give-feedback-button"
          dataKey="give-feedback-button"
          handleClick={this.handleOpen}
        >
          <FormattedMessage id="give_feedback" />
        </SecondaryGhostButton>
      </div>
    );
  }

  renderActions () {
    return this.props.optedIn ? this.renderOptOutActions() : this.renderOptInActions();
  }

  render () {
    return (
      <div className="cp-preview-bar">
        <div className="bar-wrapper">
          <div className="bar-description">
            <FormattedMessage id={`preview_bar_description_${this.props.featureName}`} />
          </div>
          {this.renderActions()}
          {this.renderFeedbackModal()}
        </div>
      </div>
    );
  }
}

PreviewBar.defaultProps = {
  optedIn: true,
  previewActions: {
    dismissPreview: () => {},
    optIn: () => {}
  }
};

PreviewBar.propTypes = {
  featureName: PropTypes.string.isRequired,
  location: locationShape,
  modalActions: PropTypes.objectOf(PropTypes.func),
  optedIn: PropTypes.bool,
  previewActions: PropTypes.objectOf(PropTypes.func),
  previewTransactions: ImmutablePropTypes.map
};
